import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceSummaryRowDetailsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    isNonRunner?: boolean;
}

const setRaceSummaryRowDetailsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isNonRunner?: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: 0 0 8px 8px;
            opacity: ${isNonRunner === true ? 0.4 : 1};
        `;
    }
    return css`
        border-style: solid;
        border-color: ${theme.star.raceSummary.borderColor};
        border-width: 0 0 1px 0;
        @media ${theme.star.mediaQuery.tablet} {
            border-width: 0 1px 1px 1px;
        }
    `;
};

export const RaceSummaryRowDetailsWrapper = withConfig(theme => styled('li', { label: 'RaceSummaryRowDetailsWrapper' })<RaceSummaryRowDetailsWrapperPropsType>`
    ${({ variant, isNonRunner }): SerializedStyles=> setRaceSummaryRowDetailsWrapper(variant, theme, isNonRunner)};
    background-color: ${theme.star.raceSummary.bgColor};
    padding: ${theme.star.padding.large};
`);

export const HeadingRaceDetailsWrapper = withConfig(theme => styled('header', { label: 'HeadingRaceDetailsWrapper' })`
    color: ${theme.star.raceCard.stats.txtColor};
    display: flex;
    flex-flow: column nowrap;
    font-size: ${theme.star.fontSize.xSmall};
    gap: 2px;
    line-height: 1.4;
    margin-bottom: 24px;
`);

export const HeadingRaceDetails = withConfig(theme => styled('h4', { label: 'HeadingRaceDetails' })`
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
    margin: 0;
`);

export const HeadingRaceDetailsComment = withConfig(theme => styled('span', { label: 'HeadingRaceDetailsComment' })`
    color: ${theme.star.raceCard.stats.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
`);

export const DetailsItemEmpty = withConfig(theme => styled('span', { label: 'DetailsItemEmpty' })`
    color: ${theme.star.raceCard.stats.txtColor};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
`);

export const DetailsTable = styled('div', { label: 'DetailsTable' })`
    display: flex;
    flex-flow: column nowrap;
`;

interface TheadWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const TheadWrapper = withConfig(theme => styled('div', { label: 'TheadWrapper' })<TheadWrapperPropsType>`
    background: ${theme.star.raceCard.stats.bgColorSecondary};
    display: flex;
    flex-flow: row nowrap;
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
`);

const setTheadCell = (theme: EmotionTheme): SerializedStyles => {
    return css`
        font-size: ${theme.star.fontSize.small};
        font-weight: ${theme.star.fontWeight.bold};
        line-height: 1.3334;
        padding: 4px 8px;
    `;
};

export const TheadCellFirst = withConfig(theme => styled('div', { label: 'TheadCellFirst' })`
    ${setTheadCell(theme)};
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 72px;
`);

export const columnShift = 'calc(50% + 146px)';

export const TheadCell = withConfig(theme => styled('div', { label: 'TheadCell' })`
    ${setTheadCell(theme)};
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    &:last-of-type {
        display: none;
    }
    @media ${theme.star.mediaQuery.tablet} {
        &:last-of-type {
            display: flex;
            flex: 0 0 ${columnShift};
        }
    }
`);

export const TheadCellWrapper = styled('div', { label: 'TheadCellWrapper' })`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    justify-content: start;
`;
